var _defs, _tspan, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTs54(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "57.251484mm",
    height: "132.29167mm",
    viewBox: "0 0 57.251484 132.29167",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(6.1603091e-8,-164.70833)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g204",
    transform: "matrix(1.3838447,0,0,1.3838447,-14.170192,-23.845395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text108",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    "aria-label": "\\uE085"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path194",
    d: "m 20.187386,154.29335 c 0,0 0.360797,-5.41194 0.481062,-6.2538 0.120266,-0.84186 0.601328,-1.32292 1.443186,-1.32292 h 0.360796 c 0.962124,0.24053 5.532212,0.96212 9.380707,0.96212 13.469733,0 13.950795,-7.69699 13.950795,-9.26044 0,-1.32292 -0.360797,-2.04451 -1.443186,-2.04451 -1.202654,0 -8.659114,0.84186 -11.786016,0.84186 -3.126902,0 -11.304954,-0.7216 -12.988671,-0.96213 -1.683717,0 -2.164779,0.84186 -2.285044,1.68372 l -1.082389,21.28699 v 0.24053 c 0,1.20265 0.962123,1.44319 1.924247,1.44319 0.962124,0 1.08239,-0.84186 2.164779,-1.92425 0.962124,-0.96213 3.247168,-3.1269 6.494335,-3.1269 3.247168,0 9.861769,1.80398 9.861769,12.5076 0,10.58337 -5.652477,11.90629 -8.178052,11.90629 -0.721593,0 -1.443186,0 -2.164779,-0.3608 -0.481062,-0.24053 -1.082389,-0.60133 -1.202654,-1.32292 0,-0.60133 0.721592,-1.08239 1.202654,-1.32292 2.164779,-1.32292 3.607965,-3.72823 3.607965,-6.49434 0,-4.20929 -3.367434,-7.45646 -7.45646,-7.45646 -5.171415,0 -7.336194,3.72823 -7.576724,7.09567 -0.120266,0.60132 -0.120266,1.20265 -0.120266,1.80398 0,7.93752 5.171415,11.90628 17.077697,11.90628 11.545485,0 17.79929,-7.09566 17.79929,-15.75478 0,-8.77938 -7.095663,-15.87504 -15.875042,-15.87504 -5.532212,0 -9.621238,0.96213 -12.74814,2.76611 -0.240531,0.12026 -0.360797,0.12026 -0.481062,0.12026 -0.360797,0 -0.360797,-0.48106 -0.360797,-0.72159 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "text39",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    "aria-label": "\\uE084"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path197",
    d: "m 43.192466,214.89329 v -20.5654 c 0,-0.72159 -0.120265,-1.68372 -1.202654,-1.68372 -0.841859,0 -1.322921,0.24053 -1.924248,0.96213 l -9.140176,11.06442 c -0.360796,0.48106 -0.841858,0.96212 -0.841858,2.16478 v 8.05779 H 17.094859 c 7.69699,-6.49434 23.09097,-28.38266 23.331501,-29.46505 0,-0.12026 0.120266,-0.24053 0.120266,-0.48106 0,-0.72159 -0.721593,-1.32292 -1.443186,-1.32292 -0.841858,0 -4.810619,0.24053 -6.494335,0.24053 -1.803982,0 -6.133539,-0.24053 -6.855132,-0.24053 -0.841859,0 -2.285044,0.3608 -2.285044,1.80398 0,12.02655 -9.380707,25.37602 -12.267078,29.34478 l -0.601328,0.84186 c 0,0.12026 -0.120265,0.12026 -0.120265,0.24053 -0.120266,0.3608 -0.240531,0.84186 -0.240531,1.08239 0,0.96212 0.721593,1.68372 1.924247,1.68372 H 30.08353 v 6.01327 c 0,2.64584 -2.164779,3.36743 -3.848495,3.36743 -1.563451,0 -2.285044,0.84186 -2.285044,1.80398 0,0.96213 0.481062,2.04452 1.924247,2.04452 h 20.445131 c 0.962123,0 1.924247,-0.7216 1.924247,-2.04452 0,-1.32292 -1.202655,-1.92424 -2.164778,-1.92424 -0.962124,0 -2.886372,-0.60133 -2.886372,-3.60797 v -5.65247 h 6.975398 c 0.962123,0 1.443185,-0.7216 1.443185,-1.92425 0,-1.08239 -0.360796,-1.80398 -1.443185,-1.80398 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs54);
export default __webpack_public_path__ + "static/media/ts-5-4.a21d747af7635da3d4a4454ed5ae39f7.svg";
export { ForwardRef as ReactComponent };